import {difference, isEqual, isNil, omitBy, pick} from "lodash";

export default class SearchParametersAdapter {

    constructor(defaultSortBy = {}, defaultFilters = {}) {
        this.savedParameters = {};
        this.defaultFilters = defaultFilters;
        this.defaultSortBy = defaultSortBy;

        this.parameters = {
            page: 1,
            filters: {},
            sortBy: {},
        };

        this.parameters = {
            page: 1,
            filters: Object.assign({}, this.defaultFilters),
            sortBy: Object.assign({}, omitBy(this.defaultSortBy, isNil)),
        };
    }

    setFilters(filters = {}) {
        this.parameters.filters = this.constructor.protectFields(filters, Object.keys(this.defaultFilters));
    }

    getFilters() {
        return Object.assign({}, this.parameters.filters);
    }

    setPage(page = null) {
        this.parameters.page = page;
    }

    getPage() {
        return this.parameters.page;
    }

    setSortBy(sortBy = {}) {
        this.parameters.sortBy = this.constructor.protectFields(sortBy, Object.keys(this.defaultSortBy));
    }

    getSortBy() {
        return Object.assign({}, this.parameters.sortBy);
    }

    setSortByDataTable(columns = [], desc = []) {
        let sortBy = {};
        columns.forEach((column, index)=> {
            sortBy[column] = desc[index] ? 'desc' : 'asc';
        });
        this.setSortBy(sortBy);
    }

    getDataTableOptions() {
        let dataTableOptions = {
            sortBy: [],
            sortDesc: [],
        };

        if (this.getSortBy()) {
            dataTableOptions.sortBy = Object.keys(this.getSortBy());
            dataTableOptions.sortDesc = Object.values(this.getSortBy()).map(direction => {
                return direction === 'desc';
            });
        }

        if (this.getPage()) {
            dataTableOptions.page = this.getPage();
        }

        return dataTableOptions;
    }

    saveParameters() {
        this.savedParameters = this.getParameters();
    }

    areParametersNew() {
        return !isEqual(this.savedParameters, this.getParameters());
    }

    setParameters(parameters = {}) {
        if (parameters.sortBy) {
            this.setSortBy(parameters.sortBy ? parameters.sortBy : {});
            delete parameters.sortBy;
        }

        if (parameters.page) {
            this.setPage(parameters.page ? parameters.page : 1);
            delete parameters.page;
        }

        this.setFilters(parameters);
    }

    getParameters() {
        let parameters = this.getFilters();

        if (this.getSortBy()) {
            parameters.sortBy = this.getSortBy();
        }

        if (this.getPage()) {
            parameters.page = this.getPage();
        }

        return parameters;
    }

    reset() {
        this.setFilters(this.defaultFilters);
        this.setSortBy(this.defaultSortBy);
        this.setPage(1);
    }

    static protectFields(data = {}, allowedFields = []) {
        const tryingFields = Object.keys(data);
        const failedFields = difference(tryingFields, allowedFields);

        if (failedFields.length > 0) {
            console.warn('Trying to filter on fields that dont exist in the defaults: ' + failedFields.join(', '));
        }

        return omitBy(pick(data, allowedFields), isNil);
    }

}
